var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "t-listview__breadcrumbs" },
      [
        _vm.noResult || !_vm.$isEmpty(_vm.searchVideos)
          ? _c("div", { staticClass: "t-listview__breadcrumb" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("home.select_video.sub_title")) +
                  "\n      "
              ),
              _c("i", {
                staticClass: "mdi mdi-chevron-right mdi-18px t-dis--hide",
              }),
            ])
          : _vm._l(_vm.selectedFolders, function (folder) {
              return _c(
                "div",
                {
                  key: folder.id,
                  staticClass: "t-listview__breadcrumb",
                  on: {
                    click: function ($event) {
                      return _vm.handleFolder(folder.id, folder.title, $event)
                    },
                  },
                },
                [
                  _vm._v("\n        " + _vm._s(folder.title) + "\n        "),
                  _c("i", { staticClass: "mdi mdi-chevron-right mdi-18px" }),
                ]
              )
            }),
      ],
      2
    ),
    _vm._v(" "),
    (!_vm.loading &&
      (!_vm.$isEmpty(_vm.loadedFolders[_vm.folderId]) ||
        !_vm.$isEmpty(_vm.loadedVideos[_vm.folderId]) ||
        !_vm.$isEmpty(_vm.searchVideos))) ||
    _vm.noResult
      ? _c(
          "div",
          { staticClass: "t-listview" },
          [
            _vm.noResult
              ? _c(
                  "div",
                  {
                    staticClass:
                      "t-listview__caption t-fs--subtitle t-pad--l-st",
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t("home.select_video.no_result")) +
                        "\n    "
                    ),
                  ]
                )
              : [
                  _vm.searchVideos.length == 0
                    ? _c(
                        "ul",
                        { staticClass: "t-listview__items" },
                        _vm._l(_vm.loadedFolders[_vm.folderId], function (f) {
                          return _c(
                            "li",
                            {
                              key: f.id,
                              staticClass:
                                "t-listview__item t-listview__folder t-flex--dc",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "t-flex t-dis--flj-between t-width--100",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleFolder(
                                        f.id,
                                        f.title,
                                        $event
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "t-dis--in-flex t-dis--fla-center t-width--100",
                                    },
                                    [
                                      _vm._m(0, true),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "t-dis--in-blk t-va--mid",
                                        },
                                        [_vm._v(_vm._s(f.title))]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "t-button",
                                    {
                                      staticClass: "t-tc--brand-primary",
                                      attrs: { variant: "action" },
                                    },
                                    [
                                      _c("span", [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-chevron-right mdi-21px t-tc--dark",
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "t-dis--none" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("generic.link.open"))
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$isEmpty(_vm.loadedVideos[_vm.folderId]) ||
                  !_vm.$isEmpty(_vm.searchVideos)
                    ? _c(
                        "ul",
                        { staticClass: "t-listview__items" },
                        _vm._l(
                          _vm.searchVideos.length > 0
                            ? _vm.searchVideos
                            : _vm.loadedVideos[_vm.folderId],
                          function (v) {
                            return _c(
                              "li",
                              {
                                key: v.id,
                                staticClass:
                                  "t-listview__item t-listview__file",
                                class: { "t-disabled": _vm.isDisabled(v) },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "t-width--100 t-dis--in-flex t-dis--fla-center",
                                  },
                                  [
                                    _vm.singleSelect
                                      ? _c("t-radio", {
                                          key: v.id || v.uuid,
                                          staticClass: "t-pad--l-no",
                                          attrs: {
                                            value: v.id || v.uuid,
                                            name: "listViewRadio",
                                            checked: _vm.isSelected(v),
                                            label: v.title,
                                            "checked-icon":
                                              "mdi-animation-play",
                                            "unchecked-icon":
                                              "mdi-animation-play",
                                          },
                                          on: { update: _vm.updateVideo },
                                        })
                                      : _c("t-checkbox", {
                                          key: v.id || v.uuid,
                                          staticClass: "t-pad--l-no",
                                          attrs: {
                                            value: v.id || v.uuid,
                                            name: v.title,
                                            checked: _vm.isSelected(v),
                                            label: v.title,
                                            "checked-icon": "mdi-check-bold",
                                            "unchecked-icon":
                                              "mdi-animation-play",
                                          },
                                          on: { update: _vm.updateVideos },
                                        }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.singleSelect && !_vm.isDisabled(v)
                                  ? _c(
                                      "t-button",
                                      {
                                        staticClass:
                                          "t-tc--brand-primary t-dis--none t-listview__action",
                                        class: {
                                          "t-dis--blk":
                                            _vm.isLoading(v.id || v.uuid) ||
                                            _vm.isSelected(v),
                                        },
                                        attrs: {
                                          variant: "action",
                                          loading: _vm.isLoading(
                                            v.id || v.uuid
                                          ),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addVideo(v.id || v.uuid)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _vm.$t("generic.button.select")
                                            ) +
                                            "\n          "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          }
                        ),
                        0
                      )
                    : _vm._e(),
                ],
          ],
          2
        )
      : _vm.loading
      ? _c(
          "div",
          { staticClass: "t-listview__caption t-pad--l-st t-mar--b-sm" },
          [_c("i", { staticClass: "fas fa-circle-notch fa-fw fa-spin" })]
        )
      : _c(
          "div",
          {
            staticClass:
              "t-listview__caption t-fs--subtitle t-pad--l-st t-mar--b-sm",
          },
          [
            _vm._v(
              "\n    " + _vm._s(_vm.$t("generic.text.content_empty")) + "\n  "
            ),
          ]
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "t-icon t-icon--no-border t-mar--r-xs t-va--mid" },
      [_c("i", { staticClass: "mdi mdi-folder-multiple mdi-32px" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }